export enum ReprintWorkflowNode {
    PatientInfo = 1,
    TreatmentInfo,
    ReviewAndSubmit,
}
